import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timezone',
    standalone: false
})
export class TimezonePipe implements PipeTransform {
  transform(value: any, timezone: string, format: string): string {
    if (!value) {
      return '';
    }

    let date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    // Java ZoneId can return Z or a fixed offset, unsupported by older browsers' Intl.
    let timeZone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const offset = /^(?:UTC|GMT)?([+-])(\d{2}):(\d{2})$/.exec(timeZone);
    if (timeZone === 'Z') {
      // Guest timestamps are serialized as UTC instants; their editors display local time.
      timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } else if (offset) {
      const minutes = (Number(offset[2]) * 60 + Number(offset[3])) * (offset[1] === '+' ? 1 : -1);
      date = new Date(date.getTime() + minutes * 60000);
      timeZone = 'UTC';
    }

    switch (format) {
      case 'HH:mm':
        return new Intl.DateTimeFormat('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
          timeZone
        }).format(date);
      case 'MMM d yyyy @ HH:mm':
        return `${this.formatDateParts(date, timeZone, false)} @ ${this.formatTime(date, timeZone)}`;
      case 'dddd, MMM D YYYY @ HH:mm':
        return `${this.formatDateParts(date, timeZone, true)} @ ${this.formatTime(date, timeZone)}`;
      default:
        return new Intl.DateTimeFormat(undefined, {
          dateStyle: 'medium',
          timeStyle: 'short',
          timeZone
        }).format(date);
    }
  }

  private formatTime(date: Date, timeZone: string): string {
    return new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone
    }).format(date);
  }

  private formatDateParts(date: Date, timeZone: string, includeWeekday: boolean): string {
    const parts = new Intl.DateTimeFormat('en-US', {
      weekday: includeWeekday ? 'long' : undefined,
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone
    }).formatToParts(date);

    const part = (type: string) => {
      const found = parts.find(item => item.type === type);
      return found ? found.value : '';
    };
    const dateLabel = `${part('month')} ${part('day')} ${part('year')}`;

    return includeWeekday ? `${part('weekday')}, ${dateLabel}` : dateLabel;
  }
}
